import { createContext } from 'react';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface ToastContextValue {
  show: (type: ToastType, message: string) => void;
  success: (message: string) => void;
  info: (message: string) => void;
  warning: (message: string) => void;
  error: (message: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
